// Add multiple naturedescriptions for different images
export const abstractdescriptions = Array.from({ length: 1000 }, (_, i) => `Landscape Series`);

export const abstractcontext = Array.from({ length: 1000 }, (_, i) => `Landscape artworks bring the serenity and beauty of the natural world into your home. They create a calming atmosphere, offer a visual escape, and add depth and perspective to any space.`);

// Base AWS S3 URL
const AWS_BASE_URL = "https://vizaura.s3.eu-north-1.amazonaws.com/ArtPrints/Landscape";

// Function to get image URL with fallback between .jpg and .jpeg
const getImageUrl = (imageNumber) => {
    const jpgUrl = `${AWS_BASE_URL}/${imageNumber}.jpg`;
    const jpegUrl = `${AWS_BASE_URL}/${imageNumber}.jpeg`;

    // Return an object with both URLs for the component to handle
    return {
        jpg: jpgUrl,
        jpeg: jpegUrl
    };
};

// Seeded random generator (Mulberry32)
function mulberry32(seed) {
    return function () {
        let t = (seed += 0x6D2B79F5);
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}

// Deterministic shuffle using seed
function seededShuffle(array, seed = 123456) {
    const rng = mulberry32(seed);
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(rng() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
}

// Generate wall data
const generateWalldata = () =>
    Array.from({ length: 138 }, (_, index) => {
        const imgNum = index + 1;
        const imageUrls = getImageUrl(imgNum);

        return {
            Img: imageUrls.jpg, // Default to jpg, component will handle fallback
            ImgJpg: imageUrls.jpg, // Primary jpg URL
            ImgJpeg: imageUrls.jpeg, // Backup jpeg URL
            title: `#LS${String(imgNum).padStart(3, '0')}`,
            desc: abstractdescriptions[index] || "Default description",
            context: abstractcontext[index] || "Default context",
            btn: 'View Detail',
        };
    });

// Shuffle the data with a fixed seed
export const walldata = seededShuffle(generateWalldata(), 84);
